import { SESSION_ID_URL_PARAM } from "../../pages/Transition/Transition";
import { SessionData } from "./sessionDataSlice";

export const SESSION_DATA_LS_KEY = "sessionData";
export const ACCESS_CODE_URL_PARAM = "accesscode";
export const USER_ID_URL_PARAM = "userid";
export const POST_SURVEY_TIME_URL_PARAM = "postsurveytime";
export const DEFAULT_POST_SURVEY_TIME = 60;

const coerceNonEmptyString = (v: unknown): string | undefined => {
    if (typeof v !== "string") return undefined;
    const trimmed = v.trim();
    return trimmed.length > 0 ? trimmed : undefined;
};

const parsePositiveInt = (v: unknown): number | undefined => {
    if (typeof v !== "string") return undefined;
    const parsed = Number.parseInt(v, 10);
    return parsed > 0 ? parsed : undefined;
};

const readStoredSessionData = (): Partial<SessionData> => {
    const raw = localStorage.getItem(SESSION_DATA_LS_KEY);
    if (!raw) return {};
    try {
        const parsed = JSON.parse(raw);
        return {
            accessCode: coerceNonEmptyString(parsed.accessCode),
            userId: coerceNonEmptyString(parsed.userId),
            sessionId: coerceNonEmptyString(parsed.sessionId),
            postSurveyTimeInSeconds:
                typeof parsed.postSurveyTimeInSeconds === "number" ? parsed.postSurveyTimeInSeconds : undefined,
        };
    } catch {
        return {};
    }
};

export const initSessionDataFromBrowser = (): SessionData => {
    const params = new URL(window.location.href).searchParams;
    const stored = readStoredSessionData();

    return {
        accessCode: coerceNonEmptyString(params.get(ACCESS_CODE_URL_PARAM)) ?? stored.accessCode ?? null,
        userId: coerceNonEmptyString(params.get(USER_ID_URL_PARAM)) ?? stored.userId ?? null,
        sessionId: coerceNonEmptyString(params.get(SESSION_ID_URL_PARAM)) ?? stored.sessionId ?? null,
        postSurveyTimeInSeconds:
            parsePositiveInt(params.get(POST_SURVEY_TIME_URL_PARAM)) ??
            stored.postSurveyTimeInSeconds ??
            DEFAULT_POST_SURVEY_TIME,
    };
};
